module.exports = __webpack_public_path__ + "img/verify-user-account.58533c4e.svg";